export interface ProjectLineItem {
  description: string;
  quantity: number;
  unit?: string;
  unitPriceCents: number;
}
export interface ProjectDocumentDraft {
  kind: 'quote' | 'invoice';
  title: string;
  currency: 'CAD' | 'USD';
  lineItems: ProjectLineItem[];
  taxes: { label: string; ratePercent: number }[];
  notes: string;
  terms?: string;
  dueDate?: string;
  validUntil?: string;
  issuer: {
    name: string;
    address: string;
    email: string;
    taxRegistration?: string;
    paymentInstructions?: string;
  };
  quoteId?: string;
  quoteVersion?: number;
  subtotalCents?: number;
  taxCents?: number;
  totalCents?: number;
}
export interface ProjectDocumentVersion {
  version: number;
  publishedAt: string;
  totalCents: number;
  currency: 'CAD' | 'USD';
  fileName: string;
  sendStatus?: string;
  acceptedAt?: string;
  snapshot?: ProjectDocumentDraft;
}
export interface ProjectDocument {
  id: string;
  kind: 'quote' | 'invoice' | 'guide';
  title: string;
  draft?: ProjectDocumentDraft;
  versions: ProjectDocumentVersion[];
  paid?: boolean;
  category?: string;
}
export interface ProjectInstaller {
  id?: string;
  name: string;
  email: string;
  phone: string;
  serviceArea: string;
  website: string;
  publicDescription: string;
  internalNotes: string;
  revision?: number;
}
export interface ProjectLibraryFile {
  id: string;
  title: string;
  category: 'wifi' | 'camera' | 'other';
  fileName: string;
  size: number;
  createdAt: string;
  internalReference?: boolean;
}
export interface ConciergeProjectPayload {
  project: {
    revision: number;
    status: string;
    publicUpdate?: string;
    internalNotes?: string;
    serviceAddress?: string;
    schedule?: { start?: string; end?: string; notes?: string };
    installerProposal?: {
      id: string;
      installer: ProjectInstaller;
      quoteId?: string;
      quoteVersion?: number;
      approvedAt?: string;
      sharedAttachmentIds?: string[];
    };
    handoff?: {
      checklist?: Record<string, boolean>;
      note?: string;
      at?: string;
      sharedAttachmentIds?: string[];
    };
    documents: ProjectDocument[];
    activity: {
      id?: string;
      at: string;
      action?: string;
      actor?: string;
      note?: string;
      [key: string]: unknown;
    }[];
    planning?: {
      status:
        | 'received'
        | 'queued'
        | 'generating'
        | 'draft'
        | 'failed'
        | 'published';
      draftText: string;
      jobId?: string;
      error?: string;
      updatedAt?: string;
      reviewedAt?: string;
      publishedDocumentId?: string;
    };
  };
  installers: ProjectInstaller[];
  library: ProjectLibraryFile[];
}
export const projectMoney = (cents: number, currency: string) =>
  new Intl.NumberFormat('en', { style: 'currency', currency }).format(
    cents / 100,
  );
export function privateProjectUrl(raw: string) {
  const url = new URL(raw);
  if (
    url.protocol !== 'https:' ||
    !/^manor-concierge-media-(test-219443365041|prod-680511694845)\.s3\.(ca-central-1|us-east-1)\.amazonaws\.com$/.test(
      url.hostname,
    )
  )
    throw Error('Unexpected private file destination. Refresh and try again.');
  return url.href;
}
